import React from "react";

import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Box, Button, Paper, Stack, Typography } from "@mui/material";

import EmailSentImage from "@app/analytics/assets/emailSentSuccess.svg?react";
import useAuth from "@app/common/auth/useAuth";
import useRecaptcha from "@app/common/auth/useRecaptcha";
import ROUTES from "@app/common/routes";
import Config from "@app/config";

import Link from "@rui/Link";
import { Row } from "@rui/Stack";

import { CenteredContainer } from "./styles";

const EmailSentSuccess = () => {
  const [queryParams] = useSearchParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const { recaptchaRef, getRecaptchaValue } = useRecaptcha();
  const handleRequestPasswordReset = async () => {
    const email: string | null = queryParams.get("email");
    const recaptchaValue = await getRecaptchaValue();
    auth.requestPasswordReset(email, recaptchaValue, true);
  };

  return (
    <Stack sx={{ background: (theme) => theme.palette.background.emblem }}>
      <CenteredContainer>
        <Box sx={{ mb: "28px", width: { md: 518 } }}>
          <Paper elevation={6} sx={{ overflow: "hidden" }}>
            <Box sx={{ padding: "28px 56px 10px 56px", margin: "auto" }}>
              <Stack spacing={2}>
                <Typography variant="h2" sx={{ textAlign: "center" }}>
                  Email has been sent!
                </Typography>
                <Typography
                  variant="bodySecondaryReg"
                  sx={{ textAlign: "left" }}
                >
                  Please check your inbox and click the provided link to reset
                  your password.
                </Typography>
              </Stack>
            </Box>
            <Box sx={{ margin: "auto", textAlign: "center", py: "15px" }}>
              <EmailSentImage />
            </Box>
            <Stack sx={{ padding: "0px 56px 32px" }}>
              <Button
                variant="contained"
                sx={{ textTransform: "none", padding: "10px 0" }}
                onClick={() => navigate(ROUTES.SIGN_IN, { replace: true })}
              >
                Sign in
              </Button>
            </Stack>
            <Row variant="center" sx={{ mb: "20px" }}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={Config.recaptchaSite}
                size="invisible"
                badge="inline"
              />
            </Row>
            <Box sx={{ padding: "0px 14px 30px 14px", textAlign: "center" }}>
              <Typography variant="bodySecondaryReg" color="shades.neutral.300">
                Didn't receive an email?&nbsp;
                <Link onClick={handleRequestPasswordReset}>Resend</Link>
              </Typography>
            </Box>
          </Paper>
        </Box>
        <Box sx={{ mb: "20px" }}>
          <Typography variant="bodySecondaryReg" color="#FFF">
            Don't have an account?&nbsp;
            <Link to={ROUTES.SIGN_UP} sx={{ color: "white" }}>
              Sign up
            </Link>
            .
          </Typography>
        </Box>
      </CenteredContainer>
    </Stack>
  );
};

export default EmailSentSuccess;
